import type { GlobalPerm } from '@beaded/models'

export type CalloutAudience =
  | 'all'
  | 'global-view'
  | 'global-edit'
  | 'global-admin'

export interface CalloutDefinition {
  id: string
  title: string
  body: string
  priority: number // lower = shown first; use gaps (10, 20, 30)
  audience?: CalloutAudience // default: 'all'
  hideOnMobile?: boolean // default: false -- hides at base/sm breakpoints
}

/** Check if a user with the given global perms can see this callout */
export function isCalloutVisibleToUser(
  def: CalloutDefinition,
  global: GlobalPerm,
): boolean {
  switch (def.audience) {
    case 'global-view':
      return !!global.view
    case 'global-edit':
      return !!global.edit
    case 'global-admin':
      return !!global.admin
    default:
      return true // 'all' or undefined
  }
}

export const CALLOUT_REGISTRY: CalloutDefinition[] = [
  // Developers add entries here when shipping features
]

export const CALLOUT_PRIORITY_ORDER = [...CALLOUT_REGISTRY]
  .sort((a, b) => a.priority - b.priority)
  .map((c) => c.id)

export const CALLOUT_BY_ID = new Map(CALLOUT_REGISTRY.map((c) => [c.id, c]))
